module.exports = __webpack_public_path__ + "img/huati.c386773c.png";